import { useCallback } from "react";

function useDownloadBase64PDF() {
	// helper to convert base64 to Blob
	const base64ToBlob = (base64, fileType) => {
		const byteCharacters = atob(base64);
		const byteNumbers = new Array(byteCharacters.length);

		for (let i = 0; i < byteCharacters.length; i++) {
			byteNumbers[i] = byteCharacters.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		return new Blob([byteArray], { type: fileType });
	};

	// function to trigger the file download
	const downloadConvertedFile = useCallback(
		(input, fileType, fileName) => {
			try {
				const blob =
					input instanceof Blob
						? input
						: base64ToBlob(String(input ?? ""), fileType);
				const url = URL.createObjectURL(blob);
				const a = document.createElement("a");

				a.href = url;
				a.download = fileName;

				a.click();

				URL.revokeObjectURL(url);
			} catch (error) {
				console.error(error);
			}
		},
		[]
	);
	// function to view base64 PDF in new tab
	const viewBase64PDF = useCallback(
		(input, fileType) => {
			try {
				const blob =
					input instanceof Blob
						? input
						: base64ToBlob(String(input ?? ""), fileType);
				const url = URL.createObjectURL(blob);
				window.open(url, '_blank');
				setTimeout(() => URL.revokeObjectURL(url), 1000);
			} catch (error) {
				console.error(error);
			}
		},
		[]
	);

	return { downloadConvertedFile, viewBase64PDF };
}

export default useDownloadBase64PDF;
